import { useState, MouseEvent } from 'react';

import { downloadFile } from 'utils/file';

import { Button } from '../button';

import { DownloadButtonProps } from './types';

export const DownloadButton = ({
  url,
  fileName,
  children = 'Download',
  ...buttonProps
}: DownloadButtonProps) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async (e: MouseEvent) => {
    e.stopPropagation();

    setIsDownloading(true);
    try {
      await downloadFile(url, fileName);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Button {...buttonProps} disabled={isDownloading} onClick={handleDownload}>
      {children}
    </Button>
  );
};
